import { GridCallbackDetails, GridRowId } from '@mui/x-data-grid-premium';
import React, { useEffect, useState } from 'react';
import { DataGrid, IGridColDef, IconButton } from 'src/components';
import { translate } from 'src/i18n/tHelper';
import VwHbsIslemtanimDTO from 'src/models/GenelTanimlar/VwHbsIslemtanimDTO';
import VwHbsHastaliktanimislemDTO from 'src/models/HastalikTanim/VwHbsHastaliktanimislemDTO';
import VwUcrettarifeDTO from 'src/models/Settings/Generals/VwUcrettarifeDTO';
import { HastalikTanimApi } from 'src/services/HastalikTanim/HastalikTanimApi';
import { useGetHbsIslemtanimQuery } from 'src/services/Islem/IslemApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import HastalikTanimSlice from 'src/store/Slices/GenelTanimlar/HastalikTanimSlice';
import { UcretTarifeTanimSlice } from 'src/store/Slices/UcretTarifeTanim/UcretTarifeTanimSlice';
import SnackbarUtils from 'src/utils/SnackbarUtils';

interface UcretTarifeTanimIslemListeProps { }
const translatePath = "pages|ucretTarifeTanim";

const IslemTanimList = (props: UcretTarifeTanimIslemListeProps) => {
    const dispatch = useAppDispatch();
    const state = useGetHbsIslemtanimQuery({ });
    const hastalikTanimtaniAcitveRow = useAppSelector(s => s.hastalikTanim.hastalikTanimtaniAcitveRow);
    const kayitliIslemList = useAppSelector((state) => HastalikTanimApi.endpoints.HastalikTanimIslemGetir.select({hastaliktanimTaniId:hastalikTanimtaniAcitveRow.id})(state));
    const taniIslemList = useAppSelector(s => s.hastalikTanim.taniIslemList);
    const [selectionModel, setSelectionModel] = useState<GridRowId[]>([]);
    

    const columns: IGridColDef<VwHbsIslemtanimDTO>[] = [
        {
            field: 'id',
            headerName: translate(translatePath, 'Kayıt No'),
            width: 120,
        },
        {
            field: 'grup',
            headerName: translate(translatePath, 'Grup Adı'),
            flex: 1,
            minWidth: 100
        },
        {
            field: 'adi',
            headerName: translate(translatePath, 'İşlem Adı'),
            flex: 1,
            minWidth: 200
        },
        {
            field: 'kodu',
            headerName: translate(translatePath, 'Kodu')
        },
        {
            field: 'faturaKodu',
            headerName: translate(translatePath, 'Fatura Kodu'),
            flex: 1,
            minWidth: 120
        },
        {
            field: 'aktifBool',
            headerName: translate(translatePath, 'Aktif'),
            type: 'boolean',
            width: 75
        }
    ];

    const onRowSelectionModelChange = (rowSelectionModel: GridRowId[], details: GridCallbackDetails<any>) => {
        const newSelectionModel: GridRowId[] = [...rowSelectionModel];

        let arr = [] as Array<VwHbsHastaliktanimislemDTO>
        state.data.filter(f => newSelectionModel.includes(f.id)).forEach((row) => {
            arr.push({
                id:0,
                adet:1,
                islemtanimId: row.id,
                islemadi: row.adi,
                islemkodu: row.kodu,
                hastaliktanimtaniId: hastalikTanimtaniAcitveRow.id
            })
        })
        dispatch(HastalikTanimSlice.actions.setTaniIslemList(arr));

        setSelectionModel(newSelectionModel);
    };

    useEffect(() => {
        if(selectionModel?.length> taniIslemList?.length)
        {
            let item = selectionModel.filter( f=> taniIslemList.find(x => x.islemtanimId === f) )
            setSelectionModel(item)
        }
    }, [taniIslemList])

    return (
        <DataGrid
            enableQuickFilter
            pinnedColumns={{ right: ['action'] }}
            sx={{ height: 370 }}
            loading={state.isFetching}
            columns={columns}
            rows={state.data ? state.data.filter(f => !(kayitliIslemList.data.find(x => x.islemtanimId === f.id))) : []}
            initialState={{
                columns: {
                    columnVisibilityModel: {
                        id: false
                    },
                }
            }}
            checkboxSelection              
            rowSelectionModel={selectionModel} 
            onRowSelectionModelChange={onRowSelectionModelChange} 
        />
    )
}

export default IslemTanimList;